import React from "react";
import "./Port.scss";
import { useSelector } from "react-redux";
import { Box, Button } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";

const Port = (props) => {
  const portList =
    useSelector((state) => state.validation.validations.port) || [];
  const portPref =
    useSelector((state) => state.auth.vtr_preferences.port) || [];
  let portPrefArray = [];
  if (portPref && Array.isArray(portPref) && portPref.length > 0) {
    for (let e = 0; e < portPref.length; e++) {
      let needPortDetails = true;
      // * Finding port details
      const portLookup = portList.find(
        (item) => item.ID === portPref[e].port_id
      );
      if (
        portPref[e].hasOwnProperty("port") &&
        portPref[e].hasOwnProperty("state") &&
        portPref[e].hasOwnProperty("port_id") &&
        !isNaN(portPref[e].port_id) &&
        portPref[e].state &&
        portPref[e].port
      ) {
        let portObject = {};

        // * Skipping pref if disabled
        if (portLookup && !portLookup.hasOwnProperty("DISABLED")) {
          portObject.NAME = portPref[e].port;
          portObject.CITY = portPref[e].port;
          portObject.STATE = portPref[e].state;
          portObject.ID = portPref[e].port_id;

          portPrefArray[portPrefArray.length] = portObject;
        }
        needPortDetails = false;
      }
      if (needPortDetails) {
        if (portLookup) {
          portPrefArray.push({ ...portLookup });
        }
      }
    }
  }

  let selectedValue = {};
  if (props.port_id) {
    const port = portList.find((item) => {
      return props.port_id === item.ID;
    });
    if (port) {
      selectedValue = { ...port };
    }
  } else {
    selectedValue = {
      NAME: props.port_name,
      CITY: props.port_city,
      STATE: props.port_state,
      ID: props.port_id,
    };
  }
  return (
    <div className="Port" data-testid="Port" key={"port_div"}>
      <Box mt={0} width="100%" align="center" key={"port_box"}>
        <h2 className="sectionTitle center">Port</h2>
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          key={"port_grid"}
          direction="column"
        >
          <Grid item xs={12} md="auto" key={"port_grid_item"}>
            <Box
              display="flex"
              flexWrap="wrap"
              justifyContent="center"
              key={"port_grid_box"}
            >
              {portPrefArray.map((port) => (
                <Box m={0.5} key={"port_box_" + port.ID}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className="form-input"
                    data-port_id={port.ID}
                    data-port_state={port.STATE}
                    data-port_city={port.CITY}
                    data-port_name={port.NAME}
                    size="large"
                    onClick={(e) =>
                      props.handlePortPreferenceChange(e, port.ID)
                    }
                    key={port.ID}
                  >
                    {port.ID + " - " + port.NAME + "," + port.STATE}
                  </Button>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="center">
          <Box>
            <Autocomplete
              id="port_complete"
              key={"port_auto"}
              options={portList}
              getOptionLabel={(option) =>
                option.ID
                  ? option.ID + " - " + option.NAME + " - " + option.STATE
                  : ""
              }
              style={{ maxWidth: 350, minWidth: 300 }}
              onChange={props.changeHandler}
              value={selectedValue}
              name={"port"}
              isOptionEqualToValue={(option) => option.ID}
              getOptionDisabled={(option) => option.DISABLED === true}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Port"
                  variant="standard"
                  helperText={getHelpText(props.helpText, "port")}
                />
              )}
            />
          </Box>
          <Box>
            <HelpText helpText={getHelpText(props.helpText, "port")} />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Port;
